import { Checkbox, CheckboxCard } from '@1trading/react/components/ui/checkbox';
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from '@1trading/react/components/ui/form';
import { Textarea } from '@1trading/react/components/ui/textarea';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ACCOUNT_PURPOSES, AccountPurpose } from '@/constants/institution';
import type { InstitutionExpectedActivityOrDefaults } from '@/features/institution/expected-activity/schema';

const InstitutionExpectedActivityFieldsetAccountPurpose = () => {
  const form = useFormContext<InstitutionExpectedActivityOrDefaults>();
  const { t } = useTranslation();
  const accountPurpose = form.watch('accountPurpose');

  return (
    <div className="space-y-6">
      <FormField
        control={form.control}
        name="accountPurpose"
        render={() => (
          <FormItem>
            <FormLabel>{t('institutionDetails.expectedActivity.accountPurpose')}*</FormLabel>
            <FormDescription>{t('institutionDetails.expectedActivity.accountPurposeDescription')}</FormDescription>
            <FormControl aria-label={t('institutionDetails.expectedActivity.accountPurpose')}>
              {/* biome-ignore lint/a11y/useSemanticElements: Makeshift checkboxgroup since it's not a native role */}
              <div className="space-y-4" role="group">
                {ACCOUNT_PURPOSES.map((option) => (
                  <FormField
                    key={option}
                    control={form.control}
                    name="accountPurpose"
                    render={({ field }) => (
                      <FormItem>
                        <CheckboxCard variant="outline">
                          <FormControl>
                            <Checkbox
                              checked={field.value?.includes(option)}
                              variant="cards"
                              onCheckedChange={(checked) => field.onChange(checked ? [...(field.value ?? []), option] : field.value?.filter((value) => value !== option))}
                            />
                          </FormControl>
                          <FormLabel contained>{t(`institutionDetails.expectedActivity.accountPurposeOptions.${option}`)}</FormLabel>
                        </CheckboxCard>
                      </FormItem>
                    )}
                  />
                ))}
              </div>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      {accountPurpose?.includes(AccountPurpose.OTHER) ? (
        <FormField
          control={form.control}
          name="accountPurposeOther"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t('institutionDetails.expectedActivity.accountPurposeOther')}*</FormLabel>
              <FormControl>
                <Textarea {...field} placeholder={t('institutionDetails.expectedActivity.placeholders.accountPurposeOther')} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      ) : null}
    </div>
  );
};
InstitutionExpectedActivityFieldsetAccountPurpose.displayName = 'InstitutionExpectedActivityFieldsetAccountPurpose';

export { InstitutionExpectedActivityFieldsetAccountPurpose };
